var _mask, _rect, _mask2, _rect2, _mask3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMergeTool = function SvgMergeTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "merge-tool_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.001,
    width: 11.487,
    height: 11.487,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.001,
    width: 11.487,
    height: 11.487,
    rx: 1,
    stroke: "#666",
    strokeWidth: 4,
    mask: "url(#merge-tool_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "merge-tool_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.513,
    y: 4.514,
    width: 11.487,
    height: 11.487,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.513,
    y: 4.514,
    width: 11.487,
    height: 11.487,
    rx: 1,
    stroke: "#666",
    strokeWidth: 4,
    mask: "url(#merge-tool_svg__b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "merge-tool_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.487 4.514a1 1 0 011 1v1.974a4 4 0 01-4 4H5.513a1 1 0 01-1-1V8.514a4 4 0 014-4h1.974z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.487 4.514a1 1 0 011 1v1.974a4 4 0 01-4 4H5.513a1 1 0 01-1-1V8.514a4 4 0 014-4h1.974z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.487 5.514v1.974h2V5.514h-2zm0 1.974a3 3 0 01-3 3v2a5 5 0 005-5h-2zm-3 3H5.513v2h1.974v-2zm-1.974 0V8.514h-2v1.974h2zm0-1.974a3 3 0 013-3v-2a5 5 0 00-5 5h2zm3-3h1.974v-2H8.513v2zm-3 4.974h-2a2 2 0 002 2v-2zm6.974-4.974a2 2 0 00-2-2v2h2z",
    fill: "#666",
    mask: "url(#merge-tool_svg__c)"
  })));
};
export default SvgMergeTool;